import { prop } from "fw";

export class DatasourceImage {
  @prop(null) imageKey!: string;
  @prop(25) width!: number;
  @prop(25) height!: number;
}
